module.exports = __webpack_public_path__ + "static/img/tulanduo.d160463.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img/tulanduo.png
// module id = I3fT
// module chunks = 1